import React from "react";
import estilo from "./styles/CargaAnime.module.css";
import blanco from "../../img/blanco.png";

function CargaAnime() {
  return (
    <div className={estilo.carga}>
      <div className={estilo.carga_parte1}>
        <div className={estilo.portada}>
          <img src={blanco} alt="portada-de-carga" />
          <div className={estilo.texto}></div>
        </div>

        <div className={estilo.informacion}>
          <div className={estilo.datos1}></div>
          <div className={estilo.datos2}></div>
          <div className={estilo.datos3}></div>
          <div className={estilo.datos4}></div>
        </div>
      </div>

      <div className={estilo.capitulos}>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
        <div className={estilo.cap}></div>
      </div>

      <div className={estilo.comentarios}></div>
    </div>
  );
}

export default CargaAnime;
